import CircularProgress from '@mui/material/CircularProgress';
import { LoadingStateProps } from './LoadingState.props';
import { StyledLoadingLabel, StyledLoadingState } from './LoadingState.styles';

const LoadingState = ({ label, minHeight, size = 28, ...props }: LoadingStateProps) => (
  <StyledLoadingState minHeight={minHeight} {...props}>
    <CircularProgress size={size} />
    {label ? <StyledLoadingLabel variant="body2">{label}</StyledLoadingLabel> : null}
  </StyledLoadingState>
);

export default LoadingState;
